import { Alert, Badge, Button, Col, Descriptions, Form, Icon, Input, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { generate_query_set, handleApiExceptions, alertify } from "../../../app_methods";
import { API_REQUESTS_STATUS_TYPES } from "../../../constants";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { EaseTable } from "../../../libs/EaseTable";
import { GstChallan, Settings } from "../../../models";
import { updateCurrentUserAction } from "../../../redux/actions";
import { Text4 } from "../../../styles";
import { ContentCard, GstConfigModal, PaginationKaBaap } from "../../Common";
import { PermissionHoc } from "../../HOC";
import { getGSTColumns, gstTableFilterNodes } from "./constants";
import { GSTDetails } from "./details";
import { TutorialModal } from "../../../layouts/AppLayout/tutorialModal";
import { STATUSTYPES } from './constants'

const GST = (props) => {
  const [showGSTModal, setshowGSTModal] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 15,
    current: 1,
    hasNext: true,
    showing: { from: 1, to: 15 },
  });
  const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
  const [showGSTDetailsDrawer, setShowGSTDetailsDrawer] = useState(false);
  const [activedata, setActiveData] = useState({});
  const [filters, setFilters] = useState({});
  const [gstChallans, setGSTChallans] = useState([]);
  const [approvalFlow, setapprovalFlow] = useState(false);
  const [showTutorialModal, setShowTutorialModal] = useState(false);
  const [isGuideVisible, setIsGuideVisible] = useState(window.localStorage.getItem("isGstGuideVisible") !== "FALSE")

  const fetchList = async (_pagination = pagination, _filters = filters) => {
    setIsTableLoading(true);
    const response = await GstChallan.list({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ..._filters });
    if (!response.success) {
      setIsTableLoading(false);
      handleApiExceptions(response);
      return;
    }
    setGSTChallans(generate_query_set(GstChallan, response.data.results));
    setPagination({ ..._pagination, ...response.data.pagination });
    setIsTableLoading(false);
    if (activedata.id) {
      setActiveData(new GstChallan(response.data.results.find(x => x.id === activedata.id)))
    }
  };

  const triggerFetchChallans = async () => {
    setIsTableLoading(true);
    const response = await GstChallan.triggerFetch();
    if (!response.success) {
      setIsTableLoading(false);
      handleApiExceptions(response);
      return;
    }
    fetchList({ ...pagination }, { ...filters });
    setIsTableLoading(false);
    if (response.data.success) {
      alertify("Success", response.data.message, "success");
    } else {
      alertify("Error", response.data.message, "error")
    }
  };

  const fetchSettings = async () => {
    setIsTableLoading(true);
    const response = await Settings.list()
    if (!response.success) {
      handleApiExceptions(response);
      return;
    }
    setapprovalFlow(response.data.tax_payments_settings.enable_tax_approver_flow);
    setIsTableLoading(false);
  }

  useEffect(() => {
    props.onChildMount();
    if ((props.current_user || {}).key) {
      fetchSettings();
      fetchList({ ...pagination }, { ...filters });
    }
  }, []);


  const toggleGSTModal = () => {
    setshowGSTModal(!showGSTModal);
  };

  const toggleGSTDetailsDrawer = (obj = {}) => {
    setActiveData(obj);
    setShowGSTDetailsDrawer(!showGSTDetailsDrawer);
  };

  const toggleStatusInfoDrawer = () => {
    setShowStatusInfoDrawer(!showStatusInfoDrawer);
  };

  const ButtonTwo = PermissionHoc(Button, "GST_CHALLAN_WRITE", {
    is_component: true,
    fallbackComponent: null,
  });

  const ButtonOne = PermissionHoc(Button, "GST_CHALLAN_WRITE", {
    is_component: true,
    fallbackComponent: null,
  });

  const toggleTutorialModal = () => {
    setShowTutorialModal(!showTutorialModal);
  };

  const tableColumns = getGSTColumns({
    toggleGSTDetailsDrawer,
    toggleStatusInfoDrawer,
  });

  let filterNodes = gstTableFilterNodes();

  const handleTableChange = (tableInfo) => {
    if (tableInfo.trigger == "columns") return;
    let _pagination = tableInfo.pagination;
    if (tableInfo.trigger == "filters") _pagination.current = 1;
    setPagination(_pagination);
    setFilters(tableInfo.filters);
    fetchList(_pagination, tableInfo.filters);
  };

  const onPageChange = (_pagination) => {
    setPagination({ ..._pagination });
    fetchList({ ..._pagination }, filters);
  };

  return (
    props.current_user.gtp ?
      <div>
        <ContentCard className="p-3">
          {
            isGuideVisible ? (
              <Alert
                message="GST Portal Guide"
                description={
                  <>
                    <div>In order to be able to fetch GST Challans on Easebuzz, you need to generate a GST Challan on the GST Portal first.</div>
                    <div><Button type="link" className="pl-0 mr-0 pr-0" onClick={toggleTutorialModal}>Click Here</Button> to see the steps to be followed on the GST Portal.</div>
                  </>
                }
                closable
                showIcon
                type="info"
                onClose={() => {
                  setIsGuideVisible(false);
                  window.localStorage.setItem("isGstGuideVisible", "FALSE")
                }}
              />
            ) : null
          }
          <div className="w-100 p-3 d-flex justify-content-end">
            {
              !isGuideVisible ? (
                <Tooltip title="GST Portal Guide">
                  <Button icon="info-circle" className="align-self-center" type="primary" ghost onClick={() => {
                    setIsGuideVisible(true);
                    window.localStorage.setItem("isGstGuideVisible", "TRUE")
                  }} />
                </Tooltip>
              ) : null
            }

            <ButtonOne
              type="primary"
              icon="setting"
              style={{ marginLeft: "10px" }}
              ghost
              onClick={() => toggleGSTModal()}
            >
              Setup GST
            </ButtonOne>

            {true && (
              <ButtonTwo onClick={triggerFetchChallans} type="primary" style={{ marginLeft: "10px" }}>
                Fetch Challans
              </ButtonTwo>
            )}
          </div>
          <div>
            <EaseTable
              rowKey="id"
              loading={isTableLoading}
              data={gstChallans}
              columns={tableColumns}
              fixedSelectable={!isMobile}
              handleTableChange={handleTableChange}
              pagination={pagination}
              totalRecords={pagination.total}
              filterNodes={filterNodes}
            />
            <PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
          </div>
        </ContentCard>

        <GSTDetails
          visible={showGSTDetailsDrawer}
          onClose={() => toggleGSTDetailsDrawer()}
          gst={activedata}
          fetchChallanList={fetchList}
          user={props.current_user}
          approvalFlow={approvalFlow}
        />
        <EaseDrawer
          visible={showStatusInfoDrawer}
          onClose={toggleStatusInfoDrawer}
          hideFooter
          title="GST Challan statuses"
          width={500}
        >
          <Descriptions
            bordered
            className="mt-3"
            size="small"
            layout="horizontal"
            column={1}
          >
            {Object.keys(STATUSTYPES).map((key, index) => {
              return (
                <Descriptions.Item
                  label={
                    <Badge
                      color={STATUSTYPES[key].color}
                      text={<Text4>{STATUSTYPES[key].label}</Text4>}
                    />
                  }
                >
                  {STATUSTYPES[key].description}
                </Descriptions.Item>
              );
            })}
          </Descriptions>
        </EaseDrawer>
        <GstConfigModal
          visible={showGSTModal}
          toggleGSTModal={toggleGSTModal}
          gst={activedata}
        />

        <TutorialModal
          visible={showTutorialModal}
          title="GST Portal Guide"
          url={"https://www.youtube.com/embed/iNPlAgbxI84"}
          toggleTutorialModal={toggleTutorialModal}
        />
      </div>
      :
      <Alert
        message="Error"
        description="You are not authorised to view this page."
        type="error"
        showIcon
      />
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(GST,"GST_CHALLAN_READ"));
